<script>
import { mapGetters, mapActions } from "vuex";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import { date_ranges } from "../../../state/helpers";
import moment from "moment";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import { formatIST } from "../../../config/moment";
// import { param } from "express/lib/request";
/**
 * Add-product component
 */
export default {
  page: {
    title: "Charger Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { DateRangePicker, Multiselect },
  data() {
    return {
      sortBy: "id",
      perPages: 5,
      sortDesc: true,
      page: 1,
      paginations: {},
      limit: 10,
      search: "",
      moment: moment,
      formatIST,
      id: "",
      date_ranges: date_ranges,
      SelectedUser: [],
      SelectedUserId: "",
      filters: {
        start_date: moment()
          .startOf("day")
          .subtract(29, "days")
          .format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
      },
      dateRange: {
        startDate: moment().startOf("day").subtract(29, "days"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      fields: [
        {
          key: "name",
          sortable: true,
          label: "Charging Stations (Unit Price)",
        },
        {
          key: "is_private",
          sortable: true,
          label: "Type",
        },
        {
          key: "city",
          sortable: true,
          label: "City",
        },
        {
          key: "bookings_count",
          sortable: true,
          label: "Bookings",
        },
        {
          key: "start_time",
          sortable: true,
          label: "Start Time",
        },
        {
          key: "end_time",
          sortable: true,
          label: "End Time",
        },
        {
          key: "action",
          sortable: false,
          label: "Action",
        },
      ],
    };
  },
  props: ["userId"],
  validations: {},
  computed: {
    ...mapGetters("report", [
      "getAllChargerReport",
      "loading",
      "chargerReportCount",
      "pagination",
      "getUserAll",
    ]),
  },
  mounted() {
    this.getChargerReports(this.page);
    this.getUserAllAction();
  },
  methods: {
    ...mapActions("report", ["getChargerReport", "getUserAllAction"]),
    getChargerReports(page = 1) {
      var filters = {
        ...this.filters,
        search: this.search,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
        perPages: this.perPages,
      };
      this.getChargerReport(filters);
    },
    updateValues(date) {
      this.filters = {
        ...this.filters,
        start_date: moment(date.startDate.toISOString()).format("YYYY-MM-DD"),
        end_date: moment(date.endDate.toISOString()).format("YYYY-MM-DD"),
        user_id: this.SelectedUserId,
      };
      this.getChargerReports();
    },
    dateFormat(classes, date) {
      this.filters = {
        ...this.filters,
        start_date: moment(date.startDate.toISOString()).format("YYYY-MM-DD"),
        end_date: moment(date.endDate.toISOString()).format("YYYY-MM-DD"),
      };
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getChargerReports();
    },
    onSelectUser(data) {
      this.SelectedUserId = data.id;
      this.filters = {
        ...this.filters,
        user_id: data.id,
      };
      this.getChargerReports();
    },
  },
  filters: {
    date(val) {
      return val ? val.toLocaleString() : "";
    },
  },
};
</script>
<template>
  <div class="row">
    <div class="col-12">
      <form action="#" @submit.prevent="typeForm">
        <!-- profile Info Start -->
        <div class="card date-picker-space">
          <div class="card-body">
            <div class="row align-items-center mb-3">
              <div class="col-3">
                <div
                  class="d-flex align-items-center justify-content-between icon-main-page"
                >
                  <h4 class="card-title page-title-left">
                    Charger Reports ({{ chargerReportCount }})
                  </h4>
                </div>
              </div>
              <div class="col-9">
                <div class="row d-flex align-items-center justify-content-end">
                  <div class="col-6">
                    <label>User</label>
                    <multiselect
                      v-model="SelectedUser"
                      id="ajax"
                      label="first_name"
                      track-by="first_name"
                      placeholder="Search By User"
                      open-direction="bottom"
                      :options="getUserAll"
                      :multiple="false"
                      :searchable="true"
                      :internal-search="true"
                      :clear-on-select="true"
                      :close-on-select="true"
                      :max-height="600"
                      :show-no-results="false"
                      :hide-selected="true"
                      @select="onSelectUser"
                    >
                      <!-- @input="searchChargerStation" -->
                    </multiselect>
                  </div>
                  <div class="col-6">
                    <div class="date-range-list">
                      <label>Start Date - End Date</label>
                      <date-range-picker
                        ref="picker"
                        :locale-data="{
                          firstDay: 1,
                          format: 'dd-mm-yyyy',
                        }"
                        :showDropdowns="true"
                        :showWeekNumbers="true"
                        opens="left"
                        v-model="dateRange"
                        class="w-100"
                        :ranges="date_ranges()"
                        @update="updateValues"
                      >
                        <template v-slot:input="picker">
                          {{
                            moment(picker.startDate.toISOString()).format(
                              "DD-MM-YYYY"
                            ) | date
                          }}
                          -
                          {{
                            moment(picker.endDate.toISOString()).format(
                              "DD-MM-YYYY"
                            ) | date
                          }}
                        </template>
                      </date-range-picker>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <b-table
                  striped
                  hover
                  :items="getAllChargerReport"
                  :update:sortBy="sortBy"
                  :update:sortDesc="sortDesc"
                  :no-local-sorting="true"
                  @sort-changed="sortingChanged"
                  :fields="fields"
                  :busy="loading"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{ $t(" Loading") }}</strong>
                    </div>
                  </template>
                  <template v-slot:cell(name)="items">
                    {{ items.item.name ? items.item.name : "" }} (₹
                    {{ items.item.price ? items.item.price : "-" }})
                  </template>
                  <template v-slot:cell(is_private)="items">
                    {{ items.item.is_private == 1 ? "Private" : "Public" }}
                  </template>
                  <template v-slot:cell(start_time)="items">
                    {{
                      items.item.is_private == 0 &&
                      formatIST(items.item.start_time)
                    }}
                  </template>
                  <template v-slot:cell(end_time)="items">
                    {{
                      items.item.is_private == 0 &&
                      formatIST(items.item.end_time)
                    }}
                  </template>
                  <template v-slot:cell(bookings_count)="items">
                    <span
                      v-if="items.item.bookings_count == '0'"
                      class="badge badge-danger"
                    >
                      {{ items.item.bookings_count }}
                    </span>
                    <span v-else class="badge badge-primary">
                      {{ items.item.bookings_count }}
                    </span>
                  </template>
                  <template v-slot:cell(cancelled_time)="items">
                    {{ formatIST(items.item.cancelled_time) }}
                  </template>
                  <template v-slot:cell(action)="items">
                    <b-button
                      @click="
                        $router.push({
                          name: 'charger-analytics',
                          params: { charger_id: base64(items.item.id) },
                        })
                      "
                      class="btn btn-sm btn-secondary btn-rounded"
                    >
                      <i class="bx bxs-bar-chart-alt-2"> Analytics</i>
                    </b-button>
                  </template>
                </b-table>
                <tr v-if="loading == false && getAllChargerReport == 0">
                  <td colspan="100%">
                    <h6 align="center">No Charger Data Found</h6>
                  </td>
                </tr>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-right"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <pagination
                        :data="pagination"
                        :limit="limit"
                        @pagination-change-page="getChargerReports"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- profile Info End -->
      </form>
    </div>
  </div>
</template>
<style>
.vue-daterange-picker {
  width: 250px !important;
}
.daterangepicker {
  width: 700px !important;
}
.card.date-picker-space {
  margin-bottom: 100px;
}
</style>
